<template>
  <div class="home">
    <div class="top_nav">

    </div>

    <div class="container">
      <div class="main_nav">
          <div class="main_nav_content">
            <!-- <img src="@/assets/logo.png" alt="" srcset="">  //乐购树购物app商城 -->
            <img src="@/assets/livelogo.png" alt="" srcset="">  <!--乐购树直播app审核商城-->
            <div class="nav_container">
              <div class="nav_item" v-for="item in nav" :key="item.index" @click="showstep(item.index)"> {{ item.title }}</div>
            </div>
          </div>
      </div>
      <div class="arrow-icon" @click="nextStep">
        <el-icon size="45" color="#fff">
          <ArrowDown />
        </el-icon>
      </div>
      <el-carousel style="height:calc(100vh - 28px);" 
        direction="vertical"
        motion-blur
        ref="carousel"
        trigger="click"
        :autoplay="false"
        @change="carouselChange"
      >
        <el-carousel-item style="height:calc(100vh - 28px);">
          <img src="../assets/home.jpg" style="height:100%;width: 100%;" alt="" srcset="">
        </el-carousel-item>
        <el-carousel-item style="height:calc(100vh - 28px);">
          <div class="company">
              <div v-if="activeIndex == 1" class="company_description" v-html="webInfo.infos" ></div>
              <div class="company_phone" v-if="activeIndex == 1">
                <div class="connect_title">  
                  <el-icon><Service /></el-icon>
                  联系我们
                </div>
                <div class="phone_item">
                  <span class="connect_name">{{ webInfo.name }}</span>
                  <div class="connect_phone">{{ webInfo.phone }}</div>
                </div>
                <div class="phone_item">
                  <span class="connect_name">{{ webInfo.nameOne }}</span>
                  <div class="connect_phone">{{ webInfo.phoneOne }}</div>
                </div>
              </div>
          </div>
        </el-carousel-item>
        <el-carousel-item style="height:calc(100vh - 28px);">
          <div class="company_news">
            <div class="news_bigTitle">
                <div class="news_bigTitle_title">
                  行业动态
                </div>
                <div class="news_bigTitle_subtitle">
                  关注行业动态，掌握最新资讯
                </div>
            </div>
            <div class="news_container">
              <el-collapse  accordion>
                <el-collapse-item v-for="(item,index) in news" :key="index" :name="index" >
                  <template #title>
                    <div class="news_title">
                      <div> {{ item.tableName }}</div>
                      <div>{{ item.time }}</div>
                    </div>
                  </template>
                  <div class="news_content" v-html="item.tableInfo"></div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item style="height:calc(100vh - 28px);">
         <div class="hire_content">
            <div class="hire">
              <h1 @click="showHire = !showHire">在线招聘</h1>
              <div class="hire_container">
                <div class="hire_list">
                    <div class="job_item"  v-for="item in recruitList" :key="item" @click="clickHire(item)">
                      <div class="job_item_name">
                        {{item.name}}
                        <div class="job_item_money">{{ item.price }}</div>
                      </div>
                      <div class="job_item_tag">
                        <div class="jtag_item" v-for="_item in item.tipsList" :key="_item">{{_item}}</div>
                      </div>
                    </div>
                </div>
                <div class="hire_right" v-if="showHire">
                  <div class="hire_description" v-if="showDescription" v-html="recruitItem.specificInformation">
                    
                  </div>
                  <div v-if="showDescription" class="hire_description_button"><el-button size="mini" type="primary" plain @click="handleHire">我要应聘</el-button></div>
                  <el-form
                    v-if="showHireForm"
                    style="width: 70%; margin: 0 auto; margin-top: 40px;"
                    :model="hireForm" 
                    label-width="auto"
                    >
                    <el-form-item label="姓名" prop="name">
                      <el-input v-model="hireForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="phone">
                      <el-input v-model="hireForm.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                      <el-input v-model="hireForm.email"></el-input>
                    </el-form-item>
                    <el-form-item label="学历" prop="degree">
                      <el-input v-model="hireForm.degree"></el-input>
                    </el-form-item>
                    <el-form-item label="工作经验" prop="workTime">
                      <el-input v-model="hireForm.workTime"></el-input>
                    </el-form-item>
                    <el-form-item label="期望薪资" prop="price">
                      <el-input v-model="hireForm.price"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="note">
                      <el-input v-model="hireForm.note"></el-input>
                    </el-form-item>
                    <el-form-item >
                      <el-button style="margin: 0 auto" type="primary" @click="confirmSubmit">提交</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              
              </div>
            </div>
         </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
// const baseUrl = '/devapi'
const baseUrl = 'https://tsmanage.legoushu.com/official'

document.title = '乐购树'

function confirmSubmit(){
  hireForm.value.pid = recruitItem.value.id
  axios({
    url:baseUrl + '/recruitRecord/insert',
    method:'post',
    data:hireForm.value
  }).then(res=>{
    console.log(res);
    ElMessage({
      message:"提交成功",
      type:'success'
    })
    resetForm()
    showHireForm.value = false
    showDescription.value = true
  })
}


let webInfo = ref({})

axios({
  url:baseUrl + '/mainInfo/list',
  method:'get'
}).then(res=>{
  webInfo.value = res.data.rows[0]
})





let showHire = ref(false)
let showHireForm = ref(false)
let showDescription = ref(false)




let recruitItem = ref('')
function clickHire(value){
  recruitItem.value = value
  showHire.value = true
  showDescription.value = true
  showHireForm.value = false
}
function handleHire(){
  showDescription.value = false
  showHireForm.value = true
}







let hireForm = ref({
  name:'',
  phone:'',
  email:'',
  degree:'',
  workTime:'',
  price:'',
  note:'',
  pid:''
})

function resetForm(){
  hireForm.value= {
  name:'',
  phone:'',
  email:'',
  degree:'',
  workTime:'',
  price:'',
  note:'',
  pid:''
}
}

function nextStep(){
  let index = activeIndex.value
  if(index++ > 4){
    activeIndex.value = 0
    carousel.value.setActiveItem(0)
  }else{
    carousel.value.setActiveItem(index++)
  }
}



let nav = ref([
  {
    title:'首页',
    index:0
  },
  {
    title:'公司简介',
    index:1
  },
  {
    title:'行业动态',
    index:2
  },
  {
    title:'在线招聘',
    index:3
  }
])



axios({url:baseUrl + '/recruit/list',method:'get'}).then(res=>{
  console.log('res', res)
  recruitList.value = res.data.rows
})
let recruitList = ref([])


axios({
  url:baseUrl + '/mainTable/list',
  methods:'get'
}).then(res=>{
  news.value = res.data.rows
})


let news = ref([])

const carousel = ref(null)
let activeIndex = ref(0)

function showstep(value){
  if(activeIndex.value == value) return ;
  carousel.value.setActiveItem(value)
  activeIndex.value = value
}
function carouselChange(index){
  activeIndex.value = index
}
</script>
<style lang="scss" scoped>
video {
  width: 100%;    /* 设置视频宽度为父容器的100% */
  height: 100%;   /* 设置视频高度为父容器的100% */
  object-fit: cover; /* 确保视频覆盖整个容器，同时保持视频的宽高比 */
}
::v-deep .el-carousel{
     .el-carousel__indicators {// 指示器
        left: unset;
        transform: unset;
        right: 2%;
    }
     .el-carousel__button {// 指示器按钮
        width: 10px;
        height: 10px;
        border: none;
        box-sizing: border-box;
        border: 1px #666 solid;
        border-radius: 50%;
       background-color: rgba($color: #fff, $alpha: 0);
    }
     .is-active .el-carousel__button {// 指示器激活按钮
        background: #00ccff;
        border: none;
    }
 
     .el-carousel__container {
        height: 100%;
    }
}



.top_nav{
  height: 28px;
  font-size: 12px;
  color: #fff;
  background-color: #000;
}
.container{
  height: calc(100vh - 28px);
  position: relative;
}
.main_nav{
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 9999;
  background-color: rgba($color: #FFF, $alpha: .9);
}
.main_nav_content{
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img{
    height: 60px;
    width: auto;
  }
}
.nav_container{
  height:  100%;
  display: flex;
  align-items: center;
  .nav_item{
    padding: 0 20px;
    cursor: pointer;
    &:hover{
      color: #00a3d2;
    }
  }
}
.company{
  height: 100%;
  background-image: url('@/assets/company.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
.company_news{
  height: 100%;
  background-image: url('@/assets/job.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
@keyframes slideInFromRight {
     0% {
         transform: translateX(300%);
         opacity: 0;
     }
     100% {
         transform: translateX(0);
         opacity: 1;
     }
 }

 ::v-deep .news_content{
  padding: 20px;
  &::-webkit-scrollbar {
      width: 5px;
      height:100%;
      background: transparent;
    }
  img {
    max-width: 100%;
    height: auto;
  }
 }
 ::v-deep .company_description{
  border-radius: 20px;
  max-height: 600px;
  width: 400px;
  position: absolute;
  top: 150px;
  right: 400px;
  overflow: auto;
  background-color: rgba($color: #000000, $alpha: 0.3);
  animation: slideInFromRight 3s ease-out;
  &::-webkit-scrollbar {
      width: 5px;
      height:100%;
      background: transparent;
    }
  img {
    max-width: 100%;
    height: auto;
  }
}

@keyframes slideInFromBottom {
     0% {
         transform: translateY(120px);
         opacity: 0;
     }
     100% {
         transform: translateY(0);
         opacity: 1;
     }
 }

.company_phone{
  // transform: translateY(120px);
  position: absolute;
  bottom: 0;
  left: 0;
  height: 120px;
  width: 100vw;
  animation: slideInFromBottom 3s ease-out;
  background-color: rgba($color: #000000, $alpha: 0.3);
  display: flex;
  align-items: center;
  color: #FFF;
}


.connect_title{
  display: flex;
  align-items: center;
  margin-left: 20%;
  font-size: 20px;
}
.phone_item{
  padding: 0 20px;
  font-size: 20px;
}
.connect_name{
  border-bottom: 1px #fff solid;
}
.news_title{
  width: 100% ;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.news_container{
  position: absolute;
  top: 30%;
  right: 10%;
  height: 50%;
  width: 40%;
  overflow: auto;
}
.news_bigTitle{
  height: 300px;
  width: 400px;
  position: absolute;
  left: 15%;
  top: 30%;
}
.news_bigTitle_title{
  margin-top: 50px;
  font-size: 40px;
  color: #FFF;
  font-weight: bold;
}
.news_bigTitle_subtitle{
  font-size: 30px;
  color: #FFF;
  margin-top: 40px;
}
.hire_content{
  height: 100%;
  background-image: url('@/assets/online.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  border: 1px #fff solid;
}
.hire_container{
  display: flex;
  margin-top: 20px;
  height: 90%;
  .hire_list{
    overflow-y: auto;
    list-style: none;
    width:400px;
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height:100%;
      background: transparent;
    }
   

  }
}
.hire{
  padding: 20px;
  background-color: rgba($color: #fff, $alpha: .7);
  height:60%;
  // width: 500px;
  margin: 0 auto ;
  border-radius: 20px;
  margin-top: 10%;
  display: inline-block;
  transition: width 2s ease-in-out;
  
}
.arrow-icon{
  position: absolute;
  left:calc(50% - 50px);
  bottom: 50px;
  height: 50px;
  width: 50px;
  z-index: 9999999;
  cursor: pointer;
}

.job_item{
  margin-bottom: 20px;
  cursor: pointer;
  border-radius: 10px;
  background-color: rgba($color: #fff, $alpha: .7);
  height: 70px;
  &:hover{
    color: #00a6a7;
  }
  .job_item_name{
    height: 35px;
    width:calc(100% - 40px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    font-size: 16px ;
  }
  .job_item_money{
    color: #fe574a;
    font-weight: 500;
    font-size: 18px;
  }
  .job_item_tag{
    height: 35px;
    width:calc(100% - 80px);
    padding: 0 20px;
    display: flex;
    overflow: hidden;
    align-items: center;
    .jtag_item{
      font-size: 14px;
      color: #666;
      padding: 4px;
      margin-right: 10px;
      background-color: #ededed;
      flex-shrink: 0;
    }
  }
}
.hire_right{
  margin-left: 20px;
  height: 100%;
  width: 500px;
  overflow: hidden;
  background-color: rgba($color: #fff, $alpha: .7);
  position: relative;
}
.hire_description{
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  
  
}
.hire_description_button{
    position: absolute;
    width: 100px;
    height: 40px;
    bottom: 20px;
    right: 20px;
  }
</style>

